// extracted by mini-css-extract-plugin
module.exports = {"webcamShareHolder":"WebcamShare_webcamShareHolder__3vYZN","webcamPreviewHolder":"WebcamShare_webcamPreviewHolder__2OeYe"};